<template>
  <div>
    <div class="login-img-wrap">
      <img src="@/assets/images/queue-login-bg.jpg" height="300" width="440" />
    </div>
    <div class="login-form">
      <p>登录查看体检排队进度</p>
      <van-cell-group>
        <van-field v-model="examNo" placeholder="请输入体检编号" label="体检编号" />
        <van-field v-model="mobile" placeholder="请输入登记的手机号码" label="手机号码" />
      </van-cell-group>
      <div class="button-content">
        <van-button type="info" size="large" @click="login()">登录</van-button>
        <p class="tips_text">只能查询当天的体检排队信息</p>
      </div>
    </div>

  </div>
</template>

<style lang="less" scoped>
.login-img-wrap {
  height: 300px;
  background-color: #52a1fe;
  // background-image: url("../../assets/images/queue-login-bg.jpg");
  background-repeat: no-repeat;
  background-size: auto 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 0;
  color: #fff;
  text-align: center;
}

.login-form {
  background-color: #ffffff;
  margin-top: 280px;
  position: relative;
  border-radius: 8px;
  height: calc(100vh - 300px);
  overflow: hidden;

  h2 {
    text-align: center;
    font-size: 20px;
    font-weight: 400;
  }

  p {
    line-height: 54px;
    font-size: 20px;
    text-align: center;
  }

  padding: 8px 16px;
}

.button-content {
  padding: 16px;

  .tips_text {
    font-size: 13px;
    color: rgb(145, 145, 145);
  }
}
</style>

<script>
import Vue from "vue";
import {
  Cell,
  CellGroup,
  Toast
} from "vant";
Vue.use(Cell).use(CellGroup);
import {
  Button
} from "vant";
Vue.use(Button);
import {
  Field
} from "vant";
Vue.use(Field);

import * as queue_api from '@/api/queueV2.js';

export default {
  data() {
    return {
      examNo: "",
      mobile: ""
    };
  },
  mounted() {
    let examno = this.$route.query.examno;
    let authkey = this.$route.query.authkey;
    if (examno && authkey) {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
      });
      queue_api.loginByKey(examno, authkey).then(res => {
        console.log(res);
        if (res && res.code == 200) {
          let userInfo = {
            key: res.data,
            examNo: examno,
            mobile: '', //todo
            expire: new Date().getTime() + 1000 * 60 * 60 * 24
          }
          localStorage.setItem("queue_user_info", JSON.stringify(userInfo));
          this.$router.push("/queue/state")
        } else {
          Toast.fail("登录失败！")
        }
        this.$toast.clear();
      })
    }
  },
  methods: {
    login() {
      // queue_api.login(this.mobile, this.examNo).then(res => {
      //   console.log(res);
      //   if (res && res.Data && res.OK) {
      //     let userInfo = {
      //       key: res.Data,
      //       examNo: this.examNo,
      //       mobile: this.mobile,
      //       expire: new Date().getTime() + 1000 * 60 * 60 * 24
      //     }
      //     localStorage.setItem("queue_user_info", JSON.stringify(userInfo));
      //     this.$router.push("/queue")
      //   } else {
      //     Toast.fail("登录失败！")
      //   }
      // })
    }
  },
};
</script>